/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { View } from '@az/starc-ui';
import styles from './styles.module.scss';
import cx from 'classnames';

type Props = {
  isLoading?: boolean;
  leftColumn?: React.ReactNode;
  middleColumn?: React.ReactNode;
  rightColumn?: React.ReactNode;
  middleTop?: React.ReactNode;
  middleBottom?: React.ReactNode;
};

// TODO Loading Skeletons
const ProductAvailabilityInfoSkeletonV2 = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isLoading = true,
  leftColumn,
  middleColumn,
  rightColumn,
  middleTop,
  middleBottom,
}: Props) => {
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  return !isDesktop ? (
    <View
      className={styles.skeletalV2MobileContainer}
      direction="column"
      wrap={false}
      attributes={{
        style: {
          flexGrow: 1,
          flexShrink: 1,
          maxWidth: '100%',
          minWidth: 0,
        },
      }}
    >
      <View.Item
        gapBefore={1}
        attributes={{
          style: {
            flexGrow: 1,
            flexShrink: 1,
            maxWidth: '100%',
            minWidth: 0,
          },
        }}
      >
        <View direction="column">{middleTop}</View>
      </View.Item>
      <View.Item
        attributes={{
          style: {
            width: '100%',
            maxWidth: '100%',
            justifyItems: 'center',
            flexGrow: 0,
          },
        }}
      >
        <View
          direction="column"
          attributes={{
            style: {
              width: '100%',
            },
          }}
        >
          {leftColumn}
        </View>
      </View.Item>
      <View.Item
        gapBefore={1}
        attributes={{
          style: {
            width: '100%',
            maxWidth: '100%',
            flexGrow: 0,
          },
        }}
      >
        <View direction="column">{rightColumn}</View>
      </View.Item>
      <View.Item
        gapBefore={1}
        attributes={{
          style: {
            flexGrow: 1,
            flexShrink: 1,
            maxWidth: '100%',
            width: '100%',
            minWidth: 0,
          },
        }}
      >
        <View direction="column">{middleBottom}</View>
      </View.Item>
    </View>
  ) : (
    <View
      direction="row"
      wrap={false}
      className={cx(styles.skeletalV2DesktopContainer, {
        [styles.paddingDesktopContainer]: isLoading,
      })}
    >
      <View.Item
        attributes={{
          style: {
            width: 'clamp(300px, calc(300px + (100% - 1140px) * 344 / 460), 644px)',
            maxWidth: '644px',
            flexGrow: 1,
          },
        }}
      >
        <View direction="column">{leftColumn}</View>
      </View.Item>
      <View.Item
        gapBefore={5}
        attributes={{
          style: {
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: '398px',
            maxWidth: '500px',
            minWidth: 0,
          },
        }}
      >
        <View direction="column">{middleColumn}</View>
      </View.Item>
      <View.Item
        gapBefore={5}
        attributes={{
          style: {
            width: 'clamp(362px, calc(362px + (100% - 1140px) * 14 / 460), 376px)',
            maxWidth: '376px',
            flexGrow: 0,
          },
        }}
      >
        <View direction="column">{rightColumn}</View>
      </View.Item>
    </View>
  );
};

export default ProductAvailabilityInfoSkeletonV2;
